import React from "react";

const BASE_WIDTH = 14;
const BASE_HEIGHT = 15;

export default function ComplianceError(props: {
  height?: number;
  width?: number;
}) {
  const width = props.width || BASE_WIDTH;
  const height = props.height || BASE_HEIGHT;

  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7 14.5C3.1339 14.5 0 11.3661 0 7.5C0 3.6339 3.1339 0.5 7 0.5C10.8661 0.5 14 3.6339 14 7.5C14 11.3661 10.8661 14.5 7 14.5ZM7 13.1C8.48521 13.1 9.90959 12.51 10.9598 11.4598C12.01 10.4096 12.6 8.98521 12.6 7.5C12.6 6.01479 12.01 4.59041 10.9598 3.5402C9.90959 2.49 8.48521 1.9 7 1.9C5.51479 1.9 4.09041 2.49 3.0402 3.5402C1.99 4.59041 1.4 6.01479 1.4 7.5C1.4 8.98521 1.99 10.4096 3.0402 11.4598C4.09041 12.51 5.51479 13.1 7 13.1Z"
        fill="#FF5050"
      />
      <path
        d="M7.01102 11C7.56967 11 8.02255 10.537 8.02255 9.96594C8.02255 9.39484 7.56967 8.93188 7.01102 8.93188C6.45236 8.93188 5.99948 9.39484 5.99948 9.96594C5.99948 10.537 6.45236 11 7.01102 11Z"
        fill="#FF5050"
      />
      <path
        d="M8.1783 5.19315C8.1783 4.53294 7.6562 4 7.01115 4C6.82011 4.00003 6.632 4.04804 6.46336 4.13979C6.29472 4.23154 6.15071 4.36423 6.04398 4.5262C5.93725 4.68818 5.87107 4.87447 5.85126 5.06871C5.83145 5.26295 5.85861 5.45919 5.93036 5.64018C6.36143 6.7347 7.01115 8.37488 7.01115 8.37488L8.09349 5.64018C8.1464 5.50257 8.1783 5.35144 8.1783 5.19315Z"
        fill="#FF5050"
      />
    </svg>
  );
}
